// extracted by mini-css-extract-plugin
export default {"header":"style__header___WjBQc","headerBackBtn":"style__headerBackBtn___ILAQm","headerText":"style__headerText___SctB7"};